<template>
  <div>
    <b-card class="md-3">
      <!-- Tabla con la lista de dispositivos-->
      <b-card-text class="sensorTable">
        <div>
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :totalRows="totalRecords"
            :search-options="{
              enabled: true,
              //trigger: 'enter',
              skipDiacritics: true,
              //searchFn: mySearchFn,
              placeholder: 'Buscar en la tabla',
              //externalQuery: searchQuery
            }"
            :sort-options="{
              enabled: true,
              initialSortBy: { field: 'tipologiasensor', type: 'asc' },
            }"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 10,
              dropdownAllowAll: false,
              //setCurrentPage: 2,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: 'Filas por pagina',
              ofLabel: 'de',
              pageLabel: 'pagina', // for 'pages' mode
              allLabel: 'Todas',
            }"
            :isLoading.sync="isLoading"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'acciones'">
                <span
                  style="margin-right: 10px"
                  @click="viewRow(props.row.uuid)"
                >
                  <i
                    class="far fa-eye fa-lg"
                    style="cursor: pointer"
                    title="Ampliar detalles de agrupación"
                  ></i>
                </span>
                <span
                  style="margin-right: 10px"
                  @click="editRow(props.row.uuid)"
                >
                  <i class="far fa-edit fa-lg" style="cursor: pointer"></i>
                </span>
                <span
                  @click="deleteModalPopup(props.row.uuid)"
                  v-if="isUserAdmin()"
                >
                  <i class="far fa-trash-alt fa-lg" style="cursor: pointer"></i>
                </span>
              </span>
            </template>

            <template slot="loadingContent">
              <table-loading />
            </template>
            <template slot="emptystate">
              <table-empty-state />
            </template>
          </vue-good-table>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>


<script>
// MIRAR EN https://xaksis.github.io/vue-good-table/guide/
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import SensorService from "@/services/SensorService";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";
import UserService from "@/services/UserService";

export default {
  name: "sensor-list",
  data() {
    return {
      sensor: [],
      currentSensor: null,
      currentIndex: -1,
      alias: "",
      isLoading: false,
      totalRecords: 0,
      columns: [
        {
          label: "# UUID",
          thClass: "text-center",
          tdClass: "text-center",
          field: "uuid",
          hidden: true,
        },
        {
          label: "Descripcion",
          field: "description",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
          width: "15%",
        },
        {
          label: "Tipo sensor",
          field: "tipologiasensor",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
        },
        {
          label: "Nodo asociado (UUID)",
          field: "nodoasociado",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
        },
        {
          label: "Número de sensor",
          field: "nSensor",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          hidden: true,
        },
        {
          label: "Ubicación asociada",
          field: "locationasociado",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          hidden: true,
        },
        {
          label: "Incidencias",
          thClass: "text-center",
          tdClass: "text-center",
          field: "incidenciassensor",
          hidden: true,
        },
        {
          label: "Fecha última medida",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaultimamedida",
        },
        {
          label: "Última modificación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaactualizacionsensor",
          hidden: true,
        },
        {
          label: "Acciones",
          thClass: "text-center",
          tdClass: "text-center",
          field: "acciones",
        },
      ],
      rows: [],
    };
  },
  components: {
    VueGoodTable,
    "table-loading": TableLoading,
    "table-empty-state": TableEmptyState,
  },
  methods: {
    retrieveSensor() {
      this.isLoading = true;
      SensorService.getAll()
        .then((response) => {
          this.sensor = response.data;
          this.totalRecords = response.data.length;

          //Cuidado esto puede cortar el lleado del array
          //en caso de que no exista algún campo
          this.populateRows();
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          console.log(e);
        });
    },

    refreshList() {
      this.rows = [];
      this.retrieveSensor();
    },

    deleteSensor(idsensor) {
      SensorService.delete(idsensor)
        .then((response) => {
          //Mostrar mensaje
          this.$notify({
            group: "notificateDiv",
            type: "pepito",
            title: "Sensor eliminado correctamente",
            text: "El sensor ha sido desvinculado",
            duration: 3000,
            speed: 1000,
          });
          //Quitar del array caragdo la Fila
          this.refreshList();
          //Refrescar tabla
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async populateRows() {
      //Create struct before insert it
      let newData = null;

      //Add to array List (Fast load)
      for await (let sensor of this.sensor) {
        //Fill the struct
        newData = {
              uuid: sensor._id,
              description: sensor.description,
              tipologiasensor: sensor.type
                ? sensor.type.alias
                : "Sin tipología",
              //estadonodo: this.device[i].status ? "Activo" : "Inactivo",
              sensoresnodo: -1,
              nodoasociado: sensor.device
                ? sensor.device.alias +
                  " (" +
                  sensor.device.uuid +
                  ")"
                : "No asociado",
              nSensor: sensor.sensor_number
                ? sensor.sensor_number
                : " - ",
              locationasociado: sensor.device
                ? sensor.device.location
                  ? sensor.device.location.alias
                  : "No asociado"
                : "No asociado",
              incidenciassensor: -1,
              fechaultimamedida: "Solicitando",
              fechaactualizacionsensor: "-",
        };
        // Add to array
        this.rows.push(newData);
      }

      // Now get last measure from each component
      for (let i = 0; i < this.rows.length; i++) {
        SensorService.getLastMeasure(this.rows[i].uuid)
          .then(async (response) => {
            //console.log(response)
            if (response.data.length > 0) {
                this.rows[i].fechaultimamedida = this.$moment(
                  response.data[0].raw_ts
                ).format("DD/MM/YYYY HH:mm:ss");
              } else {
                this.rows[i].fechaultimamedida = "Sin medida";
              }
          })
          .catch((e) => {
            console.log(e);
          });
      }

    },

      //Add to array
      /*for (let i = 0; i < this.sensor.length; i++) {
        SensorService.getLastMeasure(this.sensor[i]._id)
          .then((response) => {
            lastMeasure = response.data[0];

            //Fill the struct
            newData = {
              uuid: this.sensor[i]._id,
              description: this.sensor[i].description,
              tipologiasensor: this.sensor[i].type
                ? this.sensor[i].type.alias
                : "Sin tipología",
              //estadonodo: this.device[i].status ? "Activo" : "Inactivo",
              sensoresnodo: -1,
              nodoasociado: this.sensor[i].device
                ? this.sensor[i].device.alias +
                  " (" +
                  this.sensor[i].device.uuid +
                  ")"
                : "No asociado",
              nSensor: this.sensor[i].sensor_number
                ? this.sensor[i].sensor_number
                : " - ",
              locationasociado: this.sensor[i].device
                ? this.sensor[i].device.location
                  ? this.sensor[i].device.location.alias
                  : "No asociado"
                : "No asociado",
              incidenciassensor: -1,
              fechaultimamedida: lastMeasure
                ? this.$moment(String(lastMeasure.raw_ts))
                    .local()
                    .format("DD/MM/YYYY HH:mm:ss")
                : "Sin medida",
              fechaactualizacionsensor: this.$moment(
                String(this.sensor[i].updatedAt)
              )
                .local()
                .format("DD/MM/YYYY HH:mm:ss"),
              /*Be carefull -> inverted quote to multiple html lines -> Now as slot*/
              /*acciones: ''*/
            /*};

            //Push the data to the array
            this.rows.push(newData);
          })
          .catch((e) => {
            console.log(e);
          });
      }*/

    editRow(idsensor) {
      //Emit from child to parent idnodo to be modified
      this.$emit("rowedit", idsensor);
    },

    viewRow(idsensor) {
      //Emit from child to parent idnodo to be modified
      this.$emit("rowview", idsensor);
    },    

    deleteModalPopup(idsensor) {
      this.$bvModal
        .msgBoxConfirm(
          "Recuerde que una vez borrada el sensor no podra ser recuperada de nuevo.",
          {
            title:
              "¿Estad usted seguro de borrar el sensor seleccionado del sistema?",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Si, quiero borrarlo",
            cancelTitle: "No, me he equivocado",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.deleteSensor(idsensor);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },
  },
  mounted() {
    this.retrieveSensor();
  },
};
</script>
